/**
 * Authentication API service
 * Handles login, signup, and other auth-related endpoints
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { AUTH, SIGNIN, SIGNUP } from '../../constants';
import {
  LoginRequest,
  LoginResponse,
  SignUpRequest,
  ApiResponse,
} from '../../types';
import { ServiceResult } from '../../types/common/api.types';

export class AuthApiService extends BaseApiService {
  async login(
    credentials: LoginRequest
  ): Promise<ServiceResult<LoginResponse>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<LoginResponse> = await this.api.post(
        `${AUTH}${SIGNIN}`,
        credentials
      );
      return response.data;
    });
  }

  async signUp(userData: SignUpRequest): Promise<ServiceResult<ApiResponse>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<ApiResponse> = await this.api.post(
        `${AUTH}${SIGNUP}`,
        userData
      );
      return response.data;
    });
  }
}
